export const ENVIRONMENTS = {
  DEV: 'dev',
  TESTING: 'testing',
  PRODUCTION: 'production',
};



// WEBPACK FOOTER //
// ./src/app/common/config/env.constants.js